import { render } from "./Message.vue?vue&type=template&id=8c07daba&scoped=true&ts=true"
import script from "./Message.vue?vue&type=script&lang=ts"
export * from "./Message.vue?vue&type=script&lang=ts"

import "./Message.vue?vue&type=style&index=0&id=8c07daba&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src866133389/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8c07daba"]])

export default __exports__